import { MenuItem } from "./MenuItem";
import { MenuItemGroup } from "./MenuItemGroup";
export class Menu {
    title: string;
    items: MenuItem[];
    groups: MenuItemGroup[];
}
